import { motion } from 'framer-motion';
import { Phone, MousePointerClick, CalendarCheck, Users } from 'lucide-react';

const HowToBook = () => {
  return (
    <section className="section-padding bg-[#FFD600]" data-testid="how-to-book-section">
      <div className="max-w-5xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-10"
        >
          <h2 className="font-bebas text-4xl sm:text-5xl lg:text-6xl tracking-tighter uppercase text-black">
            Book in 60 Seconds
          </h2>
          <p className="font-outfit text-base sm:text-lg text-black/70 max-w-xl mx-auto mt-3">
            Booking your Las Vegas to Hollywood tour is fast, easy, and fully refundable. Three simple steps — that is it.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
          {[
            { step: 1, icon: CalendarCheck, title: 'Pick Your Date', desc: 'Choose any available date. We run tours daily from Las Vegas — weekdays, weekends, and holidays.' },
            { step: 2, icon: Users, title: 'Select Guests', desc: 'Add your group size. Solo travelers, couples, families, and groups of 50+ all welcome.' },
            { step: 3, icon: MousePointerClick, title: 'Book Instantly', desc: 'Confirm online in seconds. Instant confirmation sent to your email. Free cancellation available.' },
          ].map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.15 }}
              className="bg-white border-2 border-black rounded-xl shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] p-6 text-center"
              data-testid={`how-to-step-${item.step}`}
            >
              <div className="w-12 h-12 rounded-full bg-[#FF007A] border-2 border-black flex items-center justify-center mx-auto mb-4">
                <span className="font-bebas text-white text-xl">{item.step}</span>
              </div>
              <item.icon className="w-8 h-8 mx-auto mb-3 text-[#FF007A]" />
              <h3 className="font-bebas text-xl tracking-tight uppercase mb-2">{item.title}</h3>
              <p className="font-outfit text-sm text-[#4A4A4A]">{item.desc}</p>
            </motion.div>
          ))}
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a 
            href="#booking" 
            onClick={(e) => { e.preventDefault(); window.location.hash = 'booking'; }}
            className="btn-primary bg-[#FF007A] px-8 py-4 text-base" 
            data-testid="how-to-book-cta"
          >
            BOOK ONLINE NOW - $215
          </a>
          <span className="font-outfit text-sm font-bold text-black/60 uppercase">or</span>
          <a href="tel:+18777418390" className="flex items-center gap-2 bg-black text-white font-outfit font-bold px-8 py-4 rounded-xl border-2 border-black text-base" data-testid="how-to-call-cta">
            <Phone className="w-5 h-5" />
            CALL 1-877-741-8390
          </a>
        </div>
        <p className="text-center font-outfit text-sm text-black/60 mt-4">
          Our reservation team is available 24 hours a day, 7 days a week. Same-day and last-minute bookings accepted.
        </p>
      </div>
    </section>
  );
};

export default HowToBook;
